import { Controller } from "@hotwired/stimulus"
import { loadStripe } from "@stripe/stripe-js"

export default class extends Controller {
  static targets = ["element", "error", "form", "setupIntent", "submit"]
  static values = {
    clientSecret: String,
    publicKey: String,
    returnUrl: String
  }

  async connect() {
    this.stripe = await loadStripe(this.publicKeyValue)
    this.elements = this.stripe.elements({ clientSecret: this.clientSecretValue })
    this.paymentElement = this.elements.create("payment", { layout: "tabs" })
    this.paymentElement.mount(this.elementTarget)
  }

  async submit(event) {
    event.preventDefault()
    this.setBusy(true)
    this.errorTarget.textContent = ""

    const { error, setupIntent } = await this.stripe.confirmSetup({
      elements: this.elements,
      confirmParams: { return_url: this.returnUrlValue },
      redirect: "if_required"
    })

    if (error) {
      this.errorTarget.textContent = error.message
      this.setBusy(false)
      return
    }

    this.setupIntentTarget.value = setupIntent.id
    this.formTarget.requestSubmit()
  }

  setBusy(busy) {
    this.submitTarget.disabled = busy
    this.submitTarget.textContent = busy ? "Saving..." : "Save payment method"
  }
}
